const getters = {
  // 获取登陆状态
  getterCheckLogin(state) {
    return state.userId && state.isApiLoginStatus;
  },
  // 获取用户信息
  getterUserInfo(state) {
    return state.userInfo;
  },
  // 获取微信信息
  getterWxUserInfo(state) {
    return state.wxUserInfo;
  },
};
export default getters;
